import HomePageTopBar from 'components/HomePageTopBar';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const Header: FunctionComponent<Props> = ({
    className = '',
    isOpen,
    onClick,
    testId = TEST_ID
}) => (
    <header className={className} data-testid={testId}>
        <HomePageTopBar isOpen={isOpen} onClick={onClick} />
    </header>
);

export default Header;
